import { Currency } from '../types/currency/currency.mjs';

const PCT_DECIMALS = 4;
const roundPct = (n) => {
    const factor = 10 ** PCT_DECIMALS;
    return Math.round(n * factor) / factor;
};
function projectWipDerivedFromTotalEstimatedCost(contractTotalAmount, totalCostToDate, totalEstimatedCost) {
    let estimatedGrossProfit = null;
    if (contractTotalAmount !== null && totalEstimatedCost !== null) {
        estimatedGrossProfit = Currency.subtract(contractTotalAmount, totalEstimatedCost);
    }
    let percentComplete = null;
    if (totalCostToDate !== null && totalEstimatedCost !== null && totalEstimatedCost !== 0) {
        percentComplete = Math.min(100, roundPct((totalCostToDate / totalEstimatedCost) * 100));
    }
    let cumulativeRevenueEarned = null;
    if (contractTotalAmount !== null && percentComplete !== null) {
        cumulativeRevenueEarned = Currency.round(contractTotalAmount * (percentComplete / 100));
    }
    let grossProfitToBeEarned = null;
    if (estimatedGrossProfit !== null && percentComplete !== null) {
        grossProfitToBeEarned = Currency.round(estimatedGrossProfit * (1 - percentComplete / 100));
    }
    return { estimatedGrossProfit, percentComplete, cumulativeRevenueEarned, grossProfitToBeEarned };
}
function deriveWipFieldsFromAtomics(atomics) {
    const { contractTotalAmount, totalCostToDate, totalEstimatedCost } = atomics;
    const estimatedCostToComplete = totalEstimatedCost !== null && totalCostToDate !== null
        ? Currency.subtract(totalEstimatedCost, totalCostToDate)
        : null;
    return {
        estimatedCostToComplete,
        ...projectWipDerivedFromTotalEstimatedCost(contractTotalAmount, totalCostToDate, totalEstimatedCost),
    };
}
function deriveWipLineItem(atomics) {
    const { contractTotalAmount, totalCostToDate, totalEstimatedCost, totalBilledToDate } = atomics;
    const tier2 = deriveWipFieldsFromAtomics({
        contractTotalAmount,
        totalCostToDate,
        totalEstimatedCost,
    });
    let grossProfitPercent = null;
    if (tier2.estimatedGrossProfit !== null &&
        contractTotalAmount !== null &&
        contractTotalAmount !== 0) {
        grossProfitPercent = roundPct(tier2.estimatedGrossProfit / contractTotalAmount);
    }
    let grossProfitEarnedToDate = null;
    if (tier2.estimatedGrossProfit !== null && tier2.grossProfitToBeEarned !== null) {
        grossProfitEarnedToDate = Currency.subtract(tier2.estimatedGrossProfit, tier2.grossProfitToBeEarned);
    }
    let underbillings = null;
    let overbillings = null;
    if (tier2.cumulativeRevenueEarned !== null && totalBilledToDate !== null) {
        underbillings = Currency.round(Math.max(0, Currency.subtract(tier2.cumulativeRevenueEarned, totalBilledToDate)));
        overbillings = Currency.round(Math.max(0, Currency.subtract(totalBilledToDate, tier2.cumulativeRevenueEarned)));
    }
    const pureJobBorrow = overbillings;
    let cashFlowRemaining = null;
    if (contractTotalAmount !== null &&
        totalBilledToDate !== null &&
        tier2.estimatedCostToComplete !== null) {
        cashFlowRemaining = Currency.subtract(Currency.subtract(contractTotalAmount, totalBilledToDate), tier2.estimatedCostToComplete);
    }
    return {
        ...tier2,
        grossProfitPercent,
        grossProfitEarnedToDate,
        underbillings,
        overbillings,
        pureJobBorrow,
        cashFlowRemaining,
    };
}
function deriveManualWipStatementBacklog({ contractTotalAmount, totalCostToDate, totalEstimatedCost, }) {
    const { grossProfitToBeEarned } = projectWipDerivedFromTotalEstimatedCost(contractTotalAmount, totalCostToDate, totalEstimatedCost);
    return {
        backlogCost: totalEstimatedCost === null || totalCostToDate === null
            ? null
            : Currency.subtract(totalEstimatedCost, totalCostToDate),
        backlogGrossProfit: grossProfitToBeEarned === null ? null : Currency.round(grossProfitToBeEarned),
    };
}

export { deriveManualWipStatementBacklog, deriveWipFieldsFromAtomics, deriveWipLineItem, projectWipDerivedFromTotalEstimatedCost, roundPct };
